import { render, staticRenderFns } from "./StudyStart.vue?vue&type=template&id=4f0679f7&scoped=true&lang=pug"
import script from "./StudyStart.vue?vue&type=script&lang=ts"
export * from "./StudyStart.vue?vue&type=script&lang=ts"
import style0 from "./StudyStart.vue?vue&type=style&index=0&id=4f0679f7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0679f7",
  null
  
)

export default component.exports